// Slot holds on the way out of the admin scheduler (Jessica Caro, 2026-10-06).
//
// Picking a time places a 15-minute hold on the advisor's slot for this
// session (flow/scheduling/holds.py). Leaving the page must release it, and
// that release used to go out as navigator.sendBeacon, which cannot carry the
// CSRF header: production answered 403 and the abandoned pick blocked the slot
// for the full 15 minutes. A keepalive fetch survives the unload like a beacon
// and can carry the token; the beacon stays as the fallback (the release path
// is CSRF-exempt on the backend now, so even the fallback gets through).

export const RELEASE_URL = '/api/scheduling/holds/release/'

// The cookie axios reads for the x-csrftoken header (plugins/axios.js).
export function csrfToken (cookie) {
    const source = cookie !== undefined ? cookie : (typeof document !== 'undefined' ? document.cookie : '')
    const match = /(?:^|;\s*)csrftoken=([^;]*)/.exec(source || '')
    return match ? decodeURIComponent(match[1]) : ''
}

export function releaseHoldOnLeave ({ agent, time, sessionId }, { fetchImpl, beacon } = {}) {
    if (!agent || !time) return false
    const body = JSON.stringify({ agent_id: agent, time, session_id: sessionId })
    const doFetch = fetchImpl !== undefined ? fetchImpl : (typeof window !== 'undefined' && window.fetch ? window.fetch.bind(window) : null)
    const doBeacon = beacon !== undefined ? beacon : (typeof navigator !== 'undefined' && navigator.sendBeacon ? navigator.sendBeacon.bind(navigator) : null)
    try {
        if (doFetch) {
            const p = doFetch(RELEASE_URL, {
                method: 'POST',
                keepalive: true,
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', 'x-csrftoken': csrfToken() },
                body,
            })
            if (p && typeof p.catch === 'function') p.catch(() => {})
            return true
        }
        if (doBeacon) {
            doBeacon(RELEASE_URL, new Blob([body], { type: 'application/json' }))
            return true
        }
    } catch (e) {
        // The page is leaving; nothing to tell anyone.
    }
    return false
}

// One session id per browser tab, so a reload refreshes this tab's own hold
// instead of being refused as "another visitor". A new tab is a new session.
export function tabSessionId (prefix, storageKey = 'flow-scheduler-session') {
    const mint = () => prefix + Math.random().toString(36).slice(2) + Date.now().toString(36)
    try {
        const kept = window.sessionStorage.getItem(storageKey)
        if (kept && kept.startsWith(prefix)) return kept
        const fresh = mint()
        window.sessionStorage.setItem(storageKey, fresh)
        return fresh
    } catch (e) {
        return mint()
    }
}
